<template>
  <div class="operation-report-show-body-header-action-buttons flex">
    <edit-button v-if="canEdit" @click="onClickEdit"></edit-button>
    <delete-button v-if="canDelete" @click="onClickDelete"></delete-button>
  </div>
</template>

<script>
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";
import isObject from "lodash/isObject";

const EVENTS = {
  EDIT: "edit",
  DELETE: "delete",
};

export default {
  name: "OperationReportShowBodyHeaderActionButtons",

  components: {
    EditButton,
    DeleteButton,
  },

  props: {
    privilege: {
      type: Object, // { canEdit: Boolean, canDelete: Boolean }
      default: () => ({
        canEdit: false,
        canDelete: false,
      }),
    },
  },

  computed: {
    canEdit() {
      if (!isObject(this.privilege)) return false;
      return this.privilege.canEdit === true;
    },
    canDelete() {
      if (!isObject(this.privilege)) return false;
      return this.privilege.canDelete === true;
    },
  },

  methods: {
    onClickEdit() {
      this.$emit(EVENTS.EDIT);
    },
    onClickDelete() {
      this.$emit(EVENTS.DELETE);
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-show-body-header-action-buttons {
  height: 50px;
  column-gap: 20px;
}
</style>
